// @flow
import React, { PureComponent } from 'react';
import { handleTagEvent } from 'utils/tagManagerUtils';
import { socialNetworks } from 'utils/socialShareUtils';

import './ArticleSocial.css';

type Props = {
  url: string,
  title: string,
  club: string
};

class ArticleSocial extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    url: '#',
    title: '',
    club: ''
  };

  renderButtons = (): Array<React$Element<any>> => {
    const { url, title, club } = this.props;

    return Object.keys(socialNetworks).map(key => {
      const ShareButton = socialNetworks[key];
      const classNames = key === 'mail' ? 'btn btn--social btn--medium btn--primary btn--social' :
        `btn btn--social btn--medium btn--${key} btn--social`;
      const data = {
        className: `${classNames}${key === 'twitter' ? ' is-dark' : ''}`,
        url: (!url || url === '#') ? window.location.href : url,
        quote: (key === 'facebook') ? title : '',
        title: (key === 'twitter' || key === 'whatsapp' || key === 'linkedin') ? title : '',
        subject: (key === 'mail') ? title : '',
        source: key === 'linkedin' ? club : '',
      };

      return (
        <ShareButton
          {...data}
          key={`${key}-share-button`}
          beforeOnClick={handleTagEvent(
            'partage',
            `partage_${title}`,
            club,
            () => { },
            key
          )}>
          <i className={`icon icon-${key}`} />
        </ShareButton>
      );
    });
  };

  render() {
    return (
      <div className="article__social">
        {this.renderButtons()}
      </div>
    );
  }
}

export default ArticleSocial;
